import axios from '@axios'

export default {
  namespaced: true,
  state: {
    deletableUser: null,
  },
  getters: {
    getDeletableUser: state => state.deletableUser,
  },
  mutations: {
    SET_DELETABLE_USER: (state, val) => {
      state.deletableUser = val
    },
  },
  actions: {
    fetchStudentsList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/users', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchStudentProfile(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/auth/student/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchStudent(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/auth/users/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTransactionList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/transactions', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchApplicationList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/applications', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchTaskList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/application-tasks', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchProgramList(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/auth/programs', {
            params: queryParams,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/auth/users/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
